<template lang="pug">
  .custom-instructions
    .section
      .xs-12
        BackButton(url="/dashboard/how-to")
      
      .xs-12.text-center
        SectionTitle My Customized Instructions
      
      .xs-12(v-if="instructions.length")
        p.xs-f-small.lg-f-medium.max-at-tweak
          | Your instructions are customized for you based on your unique&nbsp;
          a(href="/color-advisor") hair profile
          |  &amp; color selection.

        ul.instruction-links
          li.xs-f-small.lg-f-medium.max-at-tweak(v-for="i in instructions")
            a.color-white.upper.semi-bold.xs-f-small.lg-f-medium.max-at-tweak(:href="'/custom-instructions/' + i.code" data-mr-ass="instructions-link") view my {{ i.name }}
      
      .xs-12(v-else)
        p.xs-f-small.lg-f-medium.max-at-tweak
          | You will be able to view your custom instructions for applicable products here once you have made a&nbsp;
          a(href="/shop/hair-color") purchase
          | . See FAQs for other product information.

</template>

<script>
  import BackButton from "../../BackButton";
  import SectionTitle from "../../../SectionTitle";
  import { getCustomInstructions } from "../../../../services/vueCustomerSvc";

  export default {
    name: 'CustomInstructions',
    components: {
      BackButton,
      SectionTitle
    },

    data() {
      return {
        instructions: []
      }
    },

    methods: {
      loadCustomInstructions() {
        getCustomInstructions().then(res => {
          this.instructions = res.data;
        });
      }
    },

    mounted() {
      this.loadCustomInstructions();
    }
  }
</script>

<style scoped lang="stylus">
  .custom-instructions
    padding 0.5em 5%
    
    .back
      display inline-block
      padding 0.5em 0
      
    h3
      padding 0.5em
      margin-bottom 1em
      
    .instruction-links
      padding 1.5em 0
      
      li
        background-color color-mr-purple
        margin-bottom 1em
        
        a
          display block
          padding 1em

</style>
